var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditNoFillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5268 1.09151L14.5268 1.09152L18.9085 5.47324L18.9087 5.47342C19.0404 5.605 19.011 5.77131 18.9369 5.84546L6.20162 18.5806C6.16759 18.6146 6.1194 18.6386 6.06059 18.643L1.32269 18.9992L1.32251 18.9992C1.24673 19.0049 1.15933 18.9763 1.09152 18.9085L1.09147 18.9084C1.02357 18.8405 0.995019 18.7531 1.00072 18.6774L1.00074 18.6772L1.35689 13.9394L0.44936 13.8712L1.35689 13.9394C1.36131 13.8806 1.38527 13.8324 1.41932 13.7984L14.1546 1.06322L14.1549 1.06284C14.1928 1.02495 14.2496 0.998934 14.3189 1.00003C14.3897 1.00115 14.4663 1.03103 14.5268 1.09151Z",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67899 5.67334L14.3264 10.3207",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNoFillIcon);
export default __webpack_public_path__ + "static/media/edit_no_fill_icon.cfa29110.svg";
export { ForwardRef as ReactComponent };